const users = [
  // 纪委两责系统=======================================

  // 0 danwei领导
  {
    g_person_id: '75177606504',
    name: 'c302e892e03053e9bd40decd64652a72',
    product_code: 'JW_system'
  },

  // 1 派驻填报人
  {
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'JW_system'
  },

  // 2 派驻审核员
  {
    g_person_id: '75177616233',
    name: '1d1e60fc4cee0a71c44663cdfd47da47',
    product_code: 'JW_system'
  },

  // 3 派驻审核人
  {
    g_person_id: '75177616233',
    name: '1d1e60fc4cee0a71c44663cdfd47da47',
    product_code: 'JW_system'
  },

  // 4 纪委审核员
  {
    g_person_id: '71217887811',
    name: '85ab00c86ab2f783657d8fb87b70a47f',
    product_code: 'JW_system'
  },

  // 5 党委填报员
  {
    g_person_id: '69217887798',
    name: '2a3c524a157d6548315631832fe707e2',
    product_code: 'JW_system'
  },

  // 6 派驻填报员
  {
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'JW_system'
  },

  // 7 党委填报人
  {
    g_person_id: '8422440849',
    name: 'c9a2528ba83f2477960ff92476c390c2',
    product_code: 'JW_system'
  },

  // 签到=======================================================

  // 8 签到测试
  {
    g_person_id: '69217887798',
    name: '2a3c524a157d6548315631832fe707e2',
    product_code: 'CheckIn'
  },

  // 会议系统==================================================

  {
    // 9 admin
    g_person_id: '75177594196',
    name: '2d365d00f56cb4ea2e697ce3dee297c8',
    product_code: 'MeetingRoom',
    rootId: '106'
  },
  {
    // 10 other
    g_person_id: '8422439700',
    name: 'fb2ba23934e177a0b7849e74c725cc6f',
    product_code: 'MeetingRoom',
    rootId: '106'
  },
  {
    // 11 proposel
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'MeetingRoom',
    rootId: '106'
  },

  // 通知详情
  {
    // 12 default
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'noticeDetail',
    rootId: '106'
  },

  // 任务管理
  {
    // 13 default
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'Todo',
    rootId: '106'
  },
  // 领导行程管理
  {
    // 14 default
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'Itinerary',
    rootId: '106'
  },
  // 知会通知管理
  {
    // 15 default
    g_person_id: '75177594308',
    // g_person_id: '8422439823',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    // name: '8DF887415685AD39FEFC036FC5ECCB18',
    product_code: 'Notice',
    rootId: '106'
  },
  // 知会人员管理 ===================================
  {
    // 16 管理员
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'ZhiHuiContacts',
    rootId: '451'
  },
  // 知会反馈与建议 ===================================
  {
    // 17 反馈与建议
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'Feedback',
    rootId: '106'
  },
  // 知会短信群发 ===================================
  {
    // 18 短信群发
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'ZhiHuiSmsNotice',
    rootId: '106'
  },
  {
    // 19 清廉监督信息报送系统（admin）
    g_person_id: '3025170900',
    name: 'b9ad50f60cbad41600aaf8db48be5cd8',
    product_code: 'HonestReport',
    rootId: '106'
  },
  {
    // 20 清廉监督信息报送系统(填报人)
    g_person_id: '5779303725',
    name: '53180c69565c79d9ec901f50c3784a8a',
    product_code: 'HonestReport',
    rootId: '106'
  },
  {
    // 21 请假系统 请假人
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'LeaveRequest',
    rootId: '106'
  },
  {
    // 21 请假系统 审核人
    g_person_id: '75177594308',
    name: '50b915ccd9df38d00a9a2dca1759604e',
    product_code: 'LeaveRequest',
    rootId: '106'
  }
]

export default users[14]



// WEBPACK FOOTER //
// ./src/dev-variable/users-info.js